import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  GET_ALL_APPLICATIONS_BY_BATCH,
  GET_ALL_GOHONZON_APPLICATIONS_BATCHES,
  INITIATE_GOHONZON_APPLICATIONS,
  SEARCH_MEMBERS_FOR_APPLY_GOHONZON,
  SEARCH_MEMBERS_FOR_RETURN_GOHONZON,
  SET_MEMBERS_FOR_APPLY_GOHONZON,
  SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL,
  GET_ALL_HANDOVER_APPLICATIONS,
  INITIATE_GOHONZON_TRACKING,
} from "../../actionTypes/dashboard";
import Gohonzon from "../../../services/api/gohonzon";

// onSuccess handler for gohonzon data api
const onMembersDataSuccess = (payload) => ({
  type: SET_MEMBERS_FOR_APPLY_GOHONZON,
  payload,
});

// onFail handler for gohonzon data api
const onMembersDataFail = (payload) => ({
  type: SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL,
  payload,
});

/**
 * This function handles the gohonzon data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getMembers(action) {
  try {
    const { data } = yield call(Gohonzon.searchMembers, action.payload);
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    yield put(onMembersDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * This function handles the gohonzon data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getGohonzonApplicationList(action) {
  try {
    const { data } = yield call(
      Gohonzon.getGohonzonApplications,
      action.payload
    );
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    yield put(onMembersDataFail(error));
    Sentry.captureException(error);
  }
}

function* gohonzonApplicationTracking(action) {
  try {
    const { data } = yield call(Gohonzon.gohonzonTracking, action.payload);
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    yield put(onMembersDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * This function handles the gohonzon data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getGohonzonApplicationBatches(action) {
  try {
    const body = { ...action.payload };
    delete body.memberName;
    const { data } = yield call(Gohonzon.getAllBatches, body);
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    Sentry.captureException(error);
    yield put(onMembersDataFail(error));
  }
}

function* getApplicationBatch(action) {
  try {
    console.log("BEFORE", action.payload.batchId);
    const body = { ...action.payload };
    // delete body.memberName;
    delete body.batchId;
    console.log("AFTER", action.payload.batchId);
    const { data } = yield call(
      Gohonzon.getApplicationsByBatchId,
      body,
      action.payload.batchId
    );
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    Sentry.captureException(error);
    yield put(onMembersDataFail(error));
  }
}

function* getApplicationHandoverBatches(action) {
  try {
    console.log("BEFORE", action.payload.batchId);
    const body = { ...action.payload };
    delete body.memberName;
    delete body.batchId;
    console.log("AFTER", action.payload.batchId);
    const { data } = yield call(
      Gohonzon.getHandoverBatchesForRegionSI,
      action.payload
    );
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    Sentry.captureException(error);
    yield put(onMembersDataFail(error));
  }
}

/**
 * Watcher saga for gohonzon
 */
function* watchGohonzonSaga() {
  yield takeLatest(SEARCH_MEMBERS_FOR_APPLY_GOHONZON, getMembers);
  yield takeLatest(SEARCH_MEMBERS_FOR_RETURN_GOHONZON, getMembers);
  yield takeLatest(INITIATE_GOHONZON_APPLICATIONS, getGohonzonApplicationList);
  yield takeLatest(INITIATE_GOHONZON_TRACKING, gohonzonApplicationTracking);
  yield takeLatest(
    GET_ALL_GOHONZON_APPLICATIONS_BATCHES,
    getGohonzonApplicationBatches
  );
  yield takeLatest(GET_ALL_APPLICATIONS_BY_BATCH, getApplicationBatch);
  yield takeLatest(
    GET_ALL_HANDOVER_APPLICATIONS,
    getApplicationHandoverBatches
  );
}
export default watchGohonzonSaga;
